import React, { useRef } from 'react';

import { useOutsideClick } from 'utils/custom-hooks';

import smallX from 'images/icons/X-small.png';

import './modal-wrapper.scss';

const ModalWrapper = ({children, closeModal, showX}) => {
	const modal = useRef(false);

	useOutsideClick(modal, closeModal);
	const xIcon = showX ? (
		<img
			src={smallX}
			className="close-btn"
			alt="close"
			onClick={closeModal}
		/>
	) : null;

	return (
		<div className="modal-wrapper">
			<div className="modal" ref={(node) => modal.current = node}>
				{xIcon}
				{children}
			</div>
		</div>
	);
};

export default ModalWrapper;
